export const base64ToArrayBuffer = (base64: string): ArrayBuffer => {
  // Decode the Base64 string to a binary string
  const binaryString = atob(base64);

  // Create a new ArrayBuffer with the same length as the binary string
  const buffer = new ArrayBuffer(binaryString.length);
  const uint8Array = new Uint8Array(buffer);

  // Assign each character's char code to the ArrayBuffer
  for (let i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }

  return buffer;
};
